import { getAjaxData } from "../functions/ajax-get-data";
import { loaderInstanse } from "../functions/scripts/loaderInstanse";

document.addEventListener('DOMContentLoaded', () => {
    const container = document.querySelector('.js-infinite-books');

    // Тихий выход, если контейнера нет
    if (!container) return;

    // Лог инициализации (только на нужной странице)
    console.log('LOG: Infinite Books Init');

    const { ajax_url, nonce } = window.ajax_params || {};
    let currentPage = 1;
    let isLoading = false;
    let hasMore = true;

    const sentinel = document.createElement('div');
    sentinel.className = 'books-sentinel';
    sentinel.style.height = '1px';
    container.after(sentinel);

    const observer = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && !isLoading && hasMore) {
            console.log('LOG: Trigger loading page', currentPage + 1);
            loadNextPage();
        }
    }, { rootMargin: '0px 0px 100px 0px' });

    observer.observe(sentinel);

    function loadNextPage() {
        isLoading = true;
        const nextPage = currentPage + 1;
        loaderInstanse(container, true);

        const currentIds = Array.from(container.querySelectorAll('.book-card'))
                                .map(item => item.getAttribute('data-id'))
                                .filter(Boolean);

        getAjaxData(ajax_url, 'get_books', {
            nonce: nonce,
            page: nextPage,
            exclude: currentIds.join(',')
        }, (res) => {
            console.log('LOG: Server Response:', res);

            if (res.success && res.data.html.trim() !== "") {
                container.insertAdjacentHTML('beforeend', res.data.html);

                const newItems = container.querySelectorAll('.book-card.ajax-loaded:not(.is-visible)');
                newItems.forEach((item, index) => {
                    setTimeout(() => {
                        item.classList.add('is-visible');
                    }, index * 100);
                });

                currentPage = nextPage;
                hasMore = res.data.more;
            } else {
                console.log('LOG: No more books or error');
                hasMore = false;
                observer.unobserve(sentinel);
            }

            setTimeout(() => {
                loaderInstanse(container, false);
                isLoading = false;
            }, 300);
        });
    }
});